module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_stpatricksday-a9d89ad051ee59dc1393ba9cf60b8295.jpg";